export const Common = {
    id: 1,
    value: 'COMMON',
    name: 'Common',
};
export const EContent = {
    id: 3,
    value: 'ECONTENT',
    name: 'eContent',
};
export const EdCom = {
    id: 4,
    value: 'EDCOM',
    name: 'Ed-com',
};
export const EdDrive = {
    id: 5,
    value: 'EDDRIVE',
    name: 'Ed-drive',
};
export const Error = {
    id: 6,
    value: 'ERROR',
    name: 'Error',
};
export const FacilityManagement = {
    id: 7,
    value: 'FACILITYMANAGEMENT',
    name: 'Facility Management',
};
export const LMSAdmin = {
    id: 8,
    value: 'LMSADMIN',
    name: 'LMS Admin',
};
export const MessagePortal = {
    id: 9,
    value: 'MESSAGEPORTAL',
    name: 'Message Portal',
};
export const MyProfile = {
    id: 10,
    value: 'MYPROFILE',
    name: 'My Profile',
};
export const MySpace = {
    id: 11,
    value: 'MYSPACE',
    name: 'My Space',
};
export const Organisation = {
    id: 12,
    value: 'ORGANIZATION',
    name: 'Organisation',
};
export const PeopleRecords = {
    id: 13,
    value: 'PEOPLERECORDS',
    name: 'People Records',
};
export const Programs = {
    id: 14,
    value: 'PROGRAMS',
    name: 'Programs',
};
export const SiteManagement = {
    id: 15,
    value: 'SITEMANAGEMENT',
    name: 'Site Management',
};
export const System = {
    id: 16,
    value: 'SYSTEM',
    name: 'System',
};
export const Translation = {
    id: 17,
    value: 'TRANSLATION',
    name: 'Translation',
};
export const Database = {
    id: 18,
    value: 'DATABASE',
    name: 'Database',
};
const All = [
    Common,
    EContent,
    EdDrive,
    EdCom,
    FacilityManagement,
    LMSAdmin,
    MessagePortal,
    Error,
    MySpace,
    MyProfile,
    Organisation,
    PeopleRecords,
    Programs,
    SiteManagement,
    System,
    Translation,
    Database,
];
const Basic = [
    Common,
    EContent,
    EdDrive,
    EdCom,
    FacilityManagement,
    LMSAdmin,
    MessagePortal,
    Error,
    MySpace,
    MyProfile,
    Organisation,
    PeopleRecords,
    Programs,
    SiteManagement,
    System,
    Translation,
    Database,
];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const AllByValue = All.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
export default {
    All,
    AllByValue,
    Basic,
    BasicByValue,
    Common,
    EContent,
    EdDrive,
    FacilityManagement,
    LMSAdmin,
    MySpace,
    MyProfile,
    Organisation,
    PeopleRecords,
    Programs,
    SiteManagement,
    System,
    Database,
};
